import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/travis/build/morewings/react-calendar-toolkit/node_modules/gatsby-theme-docz/src/base/Layout.js";
import { Playground, Props } from 'docz';
import { Datepicker } from 'lib';
import Weekdays from './Weekdays';
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <p><inlineCode parentName="p">{`Weekdays`}</inlineCode>{` component displays row with weekday names on the top of day calendar. It receives collection of localised weekday names.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-json"
      }}>{`{
  "short": "su",
  "narrow": "s",
  "abbreviated": "Sun",
  "wide": "Sunday",
  "numeric": 0
}
`}</code></pre>
    <p>{` Replace it with custom component.`}</p>
    <Playground __position={0} __code={'() => {\n  const style = {\n    boxSizing: \'border-box\',\n    flex: \'1 1 calc(100% / 7)\',\n    color: \'black\',\n    textAlign: \'center\',\n    padding: \'0\',\n    border: \'2px dashed pink\',\n    margin: \'2px\',\n    fontSize: \'12px\',\n    height: \'24px\',\n    lineHeight: \'24px\',\n  }\n  const CustomComponent = ({ name }) => {\n    return <div style={style}>{name.narrow}</div>\n  }\n  return (\n    <Datepicker\n      onDateSet={date => {\n        console.log(\'date set\', date)\n      }}\n      minPrecision=\"day\"\n      renderWeekDayAs={CustomComponent}\n      title=\"Demo datepicker\"\n    />\n  )\n}'} __scope={{
      props,
      DefaultLayout,
      Playground,
      Props,
      Datepicker,
      Weekdays,
      DefaultLayout,
      _frontmatter
    }} mdxType="Playground">
  {() => {
        const style = {
          boxSizing: 'border-box',
          flex: '1 1 calc(100% / 7)',
          color: 'black',
          textAlign: 'center',
          padding: '0',
          border: '2px dashed pink',
          margin: '2px',
          fontSize: '12px',
          height: '24px',
          lineHeight: '24px'
        };

        const CustomComponent = ({
          name
        }) => {
          return <div style={style}>
          {name.narrow}
        </div>;
        };

        return <Datepicker onDateSet={date => {
          console.log('date set', date);
        }} minPrecision="day" renderWeekDayAs={CustomComponent} title="Demo datepicker" mdxType="Datepicker" />;
      }}
    </Playground>
    <h2 {...{
      "id": "props"
    }}>{`Props`}</h2>
    <Props of={Weekdays} mdxType="Props" />

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      